// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Vibur);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  text-align: center;
  width: 65%;
  height: 250px;
  margin: auto;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  user-select: none;
  -webkit-box-reflect: below -384px linear-gradient(transparent, #0005);
}

.logo b {
  font: 400 50px 'Vibur';
  color: #fee;
  text-shadow: 0 -40px 100px, 0 0 2px, 0 0 1em #ff4444, 0 0 0.5em #ff4444,
    0 0 0.1em #ff4444, 0 10px 3px #000;
}
.logo b span {
  animation: blink linear infinite 3s;
}
.logo b span:nth-of-type(2) {
  animation: blink linear infinite 4s;
}
@keyframes blink {
  78% {
    color: inherit;
    text-shadow: inherit;
  }
  79% {
    color: #333;
  }
  80% {
    text-shadow: none;
  }
  81% {
    color: inherit;
    text-shadow: inherit;
  }
  82% {
    color: #333;
    text-shadow: none;
  }
  83% {
    color: inherit;
    text-shadow: inherit;
  }
  92% {
    color: #333;
    text-shadow: none;
  }
  92.5% {
    color: inherit;
    text-shadow: inherit;
  }
}
`, "",{"version":3,"sources":["webpack://./client/translatorCss/logo.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,qEAAqE;AACvE;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX;sCACoC;AACtC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;AACF","sourcesContent":["@import url(//fonts.googleapis.com/css?family=Vibur);\r\n\r\n.logo {\r\n  text-align: center;\r\n  width: 65%;\r\n  height: 250px;\r\n  margin: auto;\r\n  position: relative;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  user-select: none;\r\n  -webkit-box-reflect: below -384px linear-gradient(transparent, #0005);\r\n}\r\n\r\n.logo b {\r\n  font: 400 50px 'Vibur';\r\n  color: #fee;\r\n  text-shadow: 0 -40px 100px, 0 0 2px, 0 0 1em #ff4444, 0 0 0.5em #ff4444,\r\n    0 0 0.1em #ff4444, 0 10px 3px #000;\r\n}\r\n.logo b span {\r\n  animation: blink linear infinite 3s;\r\n}\r\n.logo b span:nth-of-type(2) {\r\n  animation: blink linear infinite 4s;\r\n}\r\n@keyframes blink {\r\n  78% {\r\n    color: inherit;\r\n    text-shadow: inherit;\r\n  }\r\n  79% {\r\n    color: #333;\r\n  }\r\n  80% {\r\n    text-shadow: none;\r\n  }\r\n  81% {\r\n    color: inherit;\r\n    text-shadow: inherit;\r\n  }\r\n  82% {\r\n    color: #333;\r\n    text-shadow: none;\r\n  }\r\n  83% {\r\n    color: inherit;\r\n    text-shadow: inherit;\r\n  }\r\n  92% {\r\n    color: #333;\r\n    text-shadow: none;\r\n  }\r\n  92.5% {\r\n    color: inherit;\r\n    text-shadow: inherit;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
